import {
    LOCATIONS_POST_FAILURE,
    LOCATIONS_POST_REQUEST,
    LOCATIONS_POST_SUCCESS,
} from 'actions';

const initialState = {
    isFetched: false,
    isFetching: false,
    hasErrors: false,
};

export const locationPostReducer = (state = initialState, action) => {
    const {type, location} = action;
    switch (type) {
        case LOCATIONS_POST_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            hasErrors: false,
            location,
        }}

        case LOCATIONS_POST_REQUEST: {return {
            ...initialState,
            isFetching: true,
            hasErrors: false,
        }}

        case LOCATIONS_POST_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: {return state}
    }
};
